import RequestAbstract from '../abstract';

export default class AccountingGatewayAccounts extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/accounting-gateway-accounts';
    }
}
